export default "__VITE_ASSET__BL6wN0L2__"